<script setup>
  import {ref} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";

  defineOptions({
    name: "ComponentPatientGenderDiverseDialog",
  });

  const refDialog = ref(null);

  function open() {
    refDialog.value.open();
  }

  function close() {
    refDialog.value.close();
  }

  defineExpose({
    open,
    close,
  });
</script>

<template>
  <ComponentDialog
    ref="refDialog"
    dialog-type="information"
    dialog-title="Achtung"
    dialog-content="Mit dem Geschlecht „divers“ können im MediCheck nicht alle Prüfungen durchgeführt werden (z. B. Gegenanzeigen)."
    :test-id="getTestId('gender-diverse')"
  />
</template>
